<template>
    <div class="nav">
      <div class="nav-center">
        <div class="nav-left">
          <img loading="lazy"  src="../../../static/img/logo/homeLogo.png" alt="">
        </div>
        <div class="tab" v-show="viewportWidth > 799">
            <div v-for="item in tabList" 
              @click="tabClickEvent(item.name)"
              class="tabItem"
              @mouseenter="handleMouseEnter(item.name)"
              @mouseleave="handleMouseLeave(item.name)"
            :key="item.name">
              <div class="nav-item-center" :class="{'isTabActive':activeName == item.name || isExperience && item.name == 'third'}">
                {{item.lable}}
              </div>
              </div>
            <div class="select-box" 
              v-show="isExperience" 
              @mouseenter="handleMouseEnter('third')"
              @mouseleave="handleMouseLeave('third')">
              <div 
              :class="{'isSelectBoxActive':queryId == item.id}"
              class="select-box-item" 
              v-for="item in selectBoxList" 
              :key="item.id" 
              @click="selectBoxClickEvent(item.id)">
                  {{item.lable}}
              </div>
            </div>
        </div>
        <div class="contractUs" @click="maskShow = true" v-show="viewportWidth > 799">
          <img loading="lazy"  :src="navPhone" alt="" class="contractUs-left">
          <div class="contractUs-right">
            contract us
          </div>
        </div>
        <div class="nav-right" v-show="viewportWidth <= 799">
           <img loading="lazy"  :src="navShow ? closeMenu : menu" alt="" class="menu" @click="handleLogoClick">
        </div>
      </div>
      <div class="nav-content-main" v-show="viewportWidth <= 799 && navShow && !isContractUs" :style="{minHeight: navShow ? '100%' : 'auto',backgroundColor: isContractUs ? '#fff' : '#09080D'}">
          <!-- <div class="nav-header">
                <img loading="lazy"  src="../../../static/img/logo/homeLogo.png" alt="" >
                <img loading="lazy"  :src="navShow ? closeMenu : menu" alt="" class="menu" @click="handleLogoClick">
          </div> -->
          <el-row class="tac" v-show="navShow && !isContractUs">
              <el-col>
                  <el-menu
                  class="el-menu-vertical-demo"
                  @select="handleSelect"
                  background-color="#545c64"
                  text-color="#fff"
                  active-text-color="#409EFF"
                  :default-active="first">
                  <el-menu-item index="first">
                      <span slot="title">Home</span>
                  </el-menu-item>
                  <el-menu-item index="second">
                      <span slot="title">Travel</span>
                  </el-menu-item>
                  <el-submenu index="third">
                      <template slot="title">
                      <span>Experience</span>
                      </template>
                      <el-menu-item index="1">Accommodations</el-menu-item>
                      <el-menu-item index="2">Traffic</el-menu-item>
                      <el-menu-item index="3">Activities</el-menu-item>
                      <el-menu-item index="4">Services</el-menu-item>
                  </el-submenu>
                  <el-menu-item index="fourth">
                      <span slot="title">About Us</span>
                  </el-menu-item>
                  <el-menu-item index="fifth">
                      <span slot="title">Move Now</span>
                  </el-menu-item>
                  </el-menu>
              </el-col>
          </el-row>
        <div class="contractUs" v-show="navShow && !isContractUs" @click="isContractUs = true">
            <img loading="lazy"  :src="navPhone" alt="" class="contractUs-left">
            <div class="contractUs-right">
                contract us
            </div>
        </div>
    </div>
    <fromMoveNow v-show="isContractUs && navShow && viewportWidth <= 799"></fromMoveNow>
      <maskFrom @closeFatherEvent="closeChildEvent" v-if="maskShow"></maskFrom>
    </div>
</template>
<script>
import navPhone from '/static/img/nav/phone.png'
import tabInfo from '/js/navList/navList.js'
import maskFrom from '/components/pc/maskFrom/maskFrom.vue'
import closeMenu from '../../../static/img/newProductDetils/swiperClose.png'
import menu from '/static/img/nav/menu.png'
import fromMoveNow from '/components/pc/bookNow/fromMoveNow.vue'
export default{
  components:{
    maskFrom,
    fromMoveNow
  },
    props:{
        // isNavScroll:Boolean,
        activeName:String
    },
    data(){
        return {
            navPhone:navPhone,
            closeMenu:closeMenu,
            menu:menu,
            tabList:tabInfo.tabList,
            selectBoxList:tabInfo.selectBoxList,
            isExperience:false,
            queryId:0,
            maskShow:false,
            viewportWidth:0,
            navShow:false,
            isContractUs:false,
        }
    },
    // watch:{
    //     isNavScroll(newVal){
    //         this.isFixrd = newVal
    //     },
    //     deep:true,
    //     immediate:true,
    // },
    mounted(){
      this.queryId = this.$route.query.navId
      this.viewportWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize);
    },
    methods:{
      handleLogoClick(){
        this.navShow =  !this.navShow
        this.isContractUs = false
      },
      handleSelect(key) {
            if(key == 'first'){
                this.$router.push('/')
            }else if(key == 'second'){
                this.$router.push('/travel')
            }else if(key == 'fourth'){
                this.$router.push('/aboutUs')
            }else if(key == 'fifth'){
                this.$router.push('/moveNow')
            }
            if(key == 1){
            this.$router.push('/experience/accommodations?navId=1')
            }else if(key == 2){
                this.$router.push('/experience/traffic?navId=2')
            }else if(key == 3){
                this.$router.push('/experience/activities?navId=3')
            }else if(key == 4){
                this.$router.push('/experience/services?navId=4')
            }
          this.navShow = false
          this.isContractUs = false
        },
        handleResize() {
          this.viewportWidth = window.innerWidth;
        },
        closeChildEvent(val){
          this.maskShow = val
        },
        tabClickEvent(name){
          if(name == 'first'){
            this.$router.push('/')
          }else if(name == 'second'){
            this.$router.push('/travel')
          }else if(name == 'third'){
            this.isExperience = true
          }else if(name == 'fourth'){
            this.$router.push('/aboutUs')
          }else if(name == 'fifth'){
            this.$router.push('/moveNow')
          }
        },
        handleMouseEnter(name){
          if(name == 'third'){
            this.isExperience = true
          }
        },
        handleMouseLeave(name){
          if(name == 'third'){
            this.isExperience = false
          }
        },
        selectBoxClickEvent(id){
            if(id == 1){
                this.$router.push('/experience/accommodations?navId=1')
            }else if(id == 2){
                this.$router.push('/experience/traffic?navId=2')
            }else if(id == 3){
                this.$router.push('/experience/activities?navId=3')
            }else if(id == 4){
                this.$router.push('/experience/services?navId=4')
            }
        }
    }
}
</script>
<style scoped lang="scss">
  @import '/style/pc/nav/nav.scss';
  @import '/style/phone/nav/nav.scss';
</style>